import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { DEFAULT_STRESS_TEST_RANGES } from '../views/pages/StressTest/stressTestRanges';
import { fetchClinicSettings, updateClinicSettings } from '../services/clinicSettings';

export const useClinicSettings = () => {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['clinic-settings'],
        queryFn: fetchClinicSettings
    });

    const mutation = useMutation({
        mutationFn: updateClinicSettings,
        onSuccess: () => {
            queryClient.invalidateQueries(['clinic-settings']);
        }
    });

    const parameters = query.data?.data?.parameters ?? null;

    return {
        settings: query.data?.data,
        parameters,
        isLoading: query.isLoading,
        error: query.error,
        saveSettings: mutation.mutate,
        isSaving: mutation.isPending,
        isSaveSuccess: mutation.isSuccess,
        isSaveError: mutation.isError
    };
};

export const useStressTestRanges = () => {
    const { parameters } = useClinicSettings();
    return parameters;
};
